const initialProps = {
  ticketTwo: {
    id: "0",
    totalTicket: 0,
    cliente: "",
  },
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET_TWO":
      return {
        ...state,
        ticketTwo: action.payload,
      };
    case "UPDATE_TICKET_TWO":
      return {
        ...state,
        ticketTwo: action.payload,
      };
    default:
      return state;
  }
}
